import type { EmbarcacoesColumnKey } from "@/modules/embarcacoes";
import type { FilterDefinition } from "@/ds";
import { exportEmbarcacoes } from "@/modules/embarcacoes";
import type { EmbarcacoesFilters, EmbarcacoesSort } from "@/modules/embarcacoes";
import { createExportFeedback, describeReportFilters, useFileExport } from "@/modules/export";
import type { ToastLike } from "@/modules/export";
import { EMBARCACOES_EXPORT_FILE_NAME } from "../embarcacoes.constants";

interface UseEmbarcacoesExportacaoParams {
  /** Colunas visíveis da tela, na ordem; a exportação leva só elas. */
  readonly colunas: readonly EmbarcacoesColumnKey[];
  readonly search: string;
  readonly filters: EmbarcacoesFilters;
  readonly sort: EmbarcacoesSort;
  readonly filterColumns: FilterDefinition[];
  /** Listagem vazia: Exportar Visualização avisa "nada a exportar" sem pedir o arquivo. */
  readonly isEmpty: boolean;
  readonly toast: ToastLike;
}

/**
 * Exportar Visualização: o arquivo é gerado pelo serviço com a busca, os filtros e a ordenação em vigor, sem paginação
 * (RN003); o PDF também atende à impressão (RN004). Sem `hub.embarcacao:exportar` o serviço devolve 403 (RN005).
 */
export function useEmbarcacoesExportacao({
  colunas,
  search,
  filters,
  sort,
  filterColumns,
  isEmpty,
  toast,
}: UseEmbarcacoesExportacaoParams) {
  return useFileExport({
    fileName: EMBARCACOES_EXPORT_FILE_NAME,
    loadFile: (format) =>
      exportEmbarcacoes({
        busca: search,
        filters,
        filtros: describeReportFilters(search, filterColumns, filters),
        sort,
        colunas,
        format,
      }),
    isEmpty: () => isEmpty,
    ...createExportFeedback(toast),
  });
}
